var React = require('react');

function BottomBlobLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M77.4682 0.179458C62.763 1.82275 55.3142 18.1785 43.9797 27.7202C33.7238 36.3538 21.2895 41.9194 14.2868 53.3671C5.76236 67.3023 -1.61 82.8786 0.30603 99.1153C2.43709 117.174 10.2068 135.92 25.2293 146.096C40.0976 156.168 59.8959 155.014 77.4682 151.386C92.6905 148.244 103.319 136.176 116.118 127.332C129.361 118.181 150.257 114.559 153.598 98.7787C156.99 82.7551 138.009 71.3251 131.119 56.4738C125.431 44.2139 126.169 29.3505 116.854 19.5765C106.494 8.7053 92.3682 -1.4856 77.4682 0.179458Z","fill":"#39A77E"}));
}

BottomBlobLeft.defaultProps = {"width":"154","height":"154","viewBox":"0 0 154 154","fill":"none"};

module.exports = BottomBlobLeft;

BottomBlobLeft.default = BottomBlobLeft;
